import { createAsyncThunk } from '@reduxjs/toolkit';
import { getValveConnectorGridsEdit } from 'application/editcomp/api/ValveConnectorGrid/ValveConnectorGridEdit';
import { selectCompEditState } from 'projectRedux/store';

export const fetchAsyncValveConnectorsEdit = createAsyncThunk(
  'editcomp/updateAsyncValveConnectorGridEdit',
  async (data: {}, thunkAPI) => {
    const response = await getValveConnectorGridsEdit();
    return response;
  },
  {
    condition(arg, thunkAPI) {
      return selectCompEditState(thunkAPI.getState()).valveConnectors.loading === 'init';
    },
  }
);
